import { CART_TOTAL_RESPONSE, SET_SELECTED_WARRANTIES } from "./actions";

let initialState = {
  selectedWarranties: [],
  cartTotal: {
    sub_total: 0,
    tax_amount: 0,
    total: 0,
  },
};

export default function register(state = initialState, action) {
  switch (action.type) {
    case CART_TOTAL_RESPONSE:
      return {
        ...state,
        cartTotal: action.payload,
      };
    case SET_SELECTED_WARRANTIES:
      return {
        ...state,
        selectedWarranties: action.payload,
      };
    default:
      return state;
  }
}
